import { Reveal } from "./Reveal";
import { useContent } from "./ContentContext";
import { useTx, txtStyle, multiline } from "./siteText";

export const Cultura = () => {
  const { settings, resolveImg } = useContent();
  const tx = useTx();
  const img = resolveImg(settings.images?.cultura) || "/media/stock/cultura.jpg";
  return (
    <section className="relative py-24 md:py-32 bg-cantina-alt overflow-hidden" data-testid="cultura-section">
      <div className="absolute inset-0 tile-watermark opacity-[0.04]" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative rotate-[-2deg]">
            <div className="frame-img bg-white p-3 rounded-3xl shadow-[0_30px_70px_rgba(23,35,59,0.18)] border border-cantina-line aspect-[4/5]">
              <img src={img} alt="Hand-painted Talavera pottery" className="w-full h-full object-cover rounded-2xl" />
            </div>
            <div className="absolute -bottom-6 -right-4 bg-cantina-blue text-cantina-cream rounded-2xl px-5 py-4 shadow-lg rotate-[4deg]">
              <span className="font-script leading-none" style={txtStyle(tx("cultura.badge"))}>{tx("cultura.badge").text}</span>
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="font-script text-cantina-terracotta mb-2" style={txtStyle(tx("cultura.eyebrow"))}>{tx("cultura.eyebrow").text}</p>
            <h2 className="font-display tracking-tight text-cantina-ink leading-[1.0] mb-6" style={txtStyle(tx("cultura.heading"))}>
              {multiline(tx("cultura.heading").text)}
            </h2>
            <div className="dash-rule w-28 mb-8" />
            <p className="font-sans leading-relaxed text-cantina-ink/70 max-w-lg mb-6" style={txtStyle(tx("cultura.body"))}>
              {tx("cultura.body").text}
            </p>
            <p className="font-script text-cantina-blue" style={txtStyle(tx("cultura.signoff"))}>{tx("cultura.signoff").text}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
